import { SignatureType } from "./signature-type";
import { User } from "./user";

export class SignatureConfiguration {

    id: number = 0;
    description!: string;
    number: number = 0;
    signatureType: SignatureType | null | undefined = new SignatureType();
    signatureUser: User | null | undefined = new User();

}